import React, { Component } from "react";
import { Link } from "react-router-dom";
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardHeader } from "mdbreact";
import HomePageNews from "./News/HomePageNews";
import { GetData } from "../api/service";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Container,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import { Button, Divider, Modal } from "antd";
import moment from "moment";
import { DownloadOutlined } from "@ant-design/icons";
import { History } from "./PanduAbout/AboutDescription";
import StickyButton from "./StickyButton";
import Announcements from "./Announcements";
import RecentNews from "./RecentNews";
import HomePageEvents from "./News/HomePageEvents";
import VideoHomePage from "./Video/VideoHomePage";
import HomePageCertificates from "./News/HomePageCertificates";
import HomePageFeatured from "./Essentials/HomePageFeatured";
import StudentsCornerHomePage from "./StudentsCorner/StudentsCornerHomePage";
import KnowYourFaculty from "./KnowYourFaculty/KnowYourFaculty";
import Hightlights from "./Hightlights";
import CollegeMap from "./CollegeMap/CollegeMap";
import HightlightShort from "./HightlightShort";
import HomePageTopDiv from "./HomePageTopDiv";
export default class HomePagePandu extends Component {
  state = {
    events: [],
    isLoaded: false,
    showHoliday: false,
    holidayData: {},
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    GetData(`/getupcomingevents`).then((resp) => {
      console.log("events", resp);
      this.setState((prevState) => {
        return {
          ...prevState,
          events: resp,
          isLoaded: true,
        };
      });
    });

    GetData(`/checkiftodayisholiday`).then((resp) => {
      if (resp != null) {
        this.setState(
          (prevState) => {
            return {
              ...prevState,
              showHoliday: resp.status,
              holidayData: {
                ...resp.data,
              },
            };
          },
          () => {
            this.showHoliday();
          }
        );
      }
    });
  };

  showHoliday() {
    if (this.state.showHoliday) {
      Modal.info({
        title: this.state.holidayData?.title,
        content: (
          <div>
            <div>
              {Array.isArray(this.state.holidayData.upload_info) &&
                this.state.holidayData.upload_info.map((el) => (
                  <img src={el.url} style={{ width: "100%" }} />
                ))}
            </div>
            From :{" "}
            {moment(this.state.holidayData?.start_date).format("DD/MM/YYYY")} to{" "}
            {moment(this.state.holidayData?.end_date).format("DD/MM/YYYY")}
            <div
              style={{ margin: 0 }}
              dangerouslySetInnerHTML={{
                __html: this.state.holidayData?.description,
              }}
            ></div>
          </div>
        ),
        onOk() {},
        centered: true,
      });
    }
  }
  render() {
    return (
      <div className="fontFix" style={{ backgroundColor: "#f7f9fc" }}>
        <RecentNews />

        <Container>
          <HomePageTopDiv />
        </Container>

        {/* ABOUT THE COLLEGE */}
        <section style={{ padding: "60px 0 40px" }}>
          <Container>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginBottom: 32,
              }}
            >
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  letterSpacing: 1.6,
                  textTransform: "uppercase",
                  color: "#2962ff",
                  background: "rgba(41, 98, 255, 0.08)",
                  padding: "4px 12px",
                  borderRadius: 4,
                  marginBottom: 12,
                }}
              >
                Welcome to Dispur College
              </span>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 700,
                  color: "#0A1F44",
                  margin: 0,
                  textAlign: "center",
                }}
              >
                About The College
              </Typography>
              <div
                style={{
                  width: 56,
                  height: 3,
                  backgroundColor: "#2962ff",
                  borderRadius: 2,
                  marginTop: 14,
                }}
              />
            </div>

            <Paper
              elevation={0}
              style={{
                display: "flex",
                flexWrap: "wrap",
                background: "#ffffff",
                borderRadius: 16,
                overflow: "hidden",
                border: "1px solid #e6e9ef",
                boxShadow: "0 8px 30px rgba(10, 31, 68, 0.06)",
              }}
            >
              <div
                style={{
                  flex: "1 1 380px",
                  minHeight: 320,
                  background:
                    "linear-gradient(135deg, rgba(10,31,68,0.85) 0%, rgba(20,48,107,0.55) 100%), url(/images/dispur.jpg) center/cover no-repeat",
                  position: "relative",
                  display: "flex",
                  alignItems: "flex-end",
                  padding: 28,
                  color: "#ffffff",
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      letterSpacing: 1.2,
                      textTransform: "uppercase",
                      opacity: 0.85,
                      marginBottom: 6,
                    }}
                  >
                    Established 1978
                  </div>
                  <div style={{ fontSize: 22, fontWeight: 700, lineHeight: 1.25 }}>
                    Dispur College, Guwahati
                  </div>
                </div>
              </div>

              <div
                style={{
                  flex: "1 1 460px",
                  padding: "36px 36px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="body1"
                  style={{
                    textAlign: "justify",
                    color: "#3a4256",
                    lineHeight: 1.75,
                    fontSize: 15,
                  }}
                >
                  Established in 1978, Dispur College is one of the premier institutions of higher education in Assam, affiliated with Gauhati University. Located in the heart of Guwahati, the primary urban center of Assam as well as the gateway to North-Eastern India, the College has consistently strived to deliver quality education while fostering the holistic development of its students.
                </Typography>
                <br />
                <Typography
                  variant="body1"
                  style={{
                    textAlign: "justify",
                    color: "#3a4256",
                    lineHeight: 1.75,
                    fontSize: 15,
                  }}
                >
                  With a commitment to academic excellence and inclusive growth, Dispur College offers Higher Secondary programme in Arts and Commerce streams, along with undergraduate courses in Arts, Commerce, and Professional Studies. From the academic session 2026–27, the College is set to expand its academic horizon by introducing postgraduate programmes in Political Science, Philosophy, Commerce, and MBA, as well as the Integrated Teacher Education Programme (ITEP). In addition, the institution also offers several certificate and skill-based courses designed to meet contemporary educational and professional demands.
                </Typography>

                <div style={{ marginTop: 24 }}>
                  <Link
                    to="/aboutus/about"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "10px 20px",
                      background:
                        "linear-gradient(135deg, #2962ff 0%, #5d8bff 100%)",
                      color: "#ffffff",
                      borderRadius: 8,
                      textDecoration: "none",
                      fontWeight: 600,
                      fontSize: 14,
                      letterSpacing: 0.3,
                      boxShadow: "0 4px 12px rgba(41, 98, 255, 0.3)",
                    }}
                  >
                    Read More <span style={{ fontSize: 16 }}>&rarr;</span>
                  </Link>
                </div>
              </div>
            </Paper>
          </Container>
        </section>

        {/* PAST RECRUITERS */}
        <section
          style={{
            padding: "60px 0 80px",
            background:
              "linear-gradient(180deg, #f7f9fc 0%, #ffffff 100%)",
          }}
        >
          <Container>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginBottom: 36,
              }}
            >
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  letterSpacing: 1.6,
                  textTransform: "uppercase",
                  color: "#2962ff",
                  background: "rgba(41, 98, 255, 0.08)",
                  padding: "4px 12px",
                  borderRadius: 4,
                  marginBottom: 12,
                }}
              >
                Industry Connect
              </span>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 700,
                  color: "#0A1F44",
                  margin: 0,
                  textAlign: "center",
                }}
              >
                Past Recuiters
              </Typography>
              <div
                style={{
                  width: 56,
                  height: 3,
                  backgroundColor: "#2962ff",
                  borderRadius: 2,
                  marginTop: 14,
                }}
              />
              <Typography
                variant="body2"
                style={{
                  color: "#5a6374",
                  marginTop: 14,
                  textAlign: "center",
                  maxWidth: 560,
                  lineHeight: 1.6,
                }}
              >
                Organisations that have partnered with the Internship &amp;
                Apprenticeship Cell to engage our students.
              </Typography>
            </div>

            <div
              style={{
                background: "#ffffff",
                border: "1px solid #e6e9ef",
                borderRadius: 16,
                padding: "28px 24px",
                boxShadow: "0 4px 20px rgba(10, 31, 68, 0.04)",
              }}
            >
              <HightlightShort type="PAST_RECRUITERS" />
            </div>
          </Container>
        </section>
      </div>
    );
  }
}
